import React from 'react';
import { FormikProps } from 'formik';
import DocumentsComponent from '../../../create-claim-modal/Steps/DocumentsComponentStep';
import { otherProductClaimFileIdentifiers } from '../../../../constants/otherProductClaimFileIdentifiers';
import { InsurerState } from '../../../../../../types/InsurerState';
import { OtherProductClaimInitialValuesType } from '../../Formik/types';

type DocumentsStepProps = FormikProps<OtherProductClaimInitialValuesType> & {
  insurers?: InsurerState[] | null;
  existingFiles?: any[];
  onDeleteExisting?: (id: string) => void;
  onExistingLabelChange?: (id: string, label: string) => void;
  onUpdateExistingLabel?: (id: string, label: string) => Promise<void> | void;
  highlightMissingLabels?: boolean;
};

const DocumentsStep = ({
  insurers,
  existingFiles,
  onDeleteExisting,
  onExistingLabelChange,
  onUpdateExistingLabel,
  highlightMissingLabels,
  ...formikProps
}: DocumentsStepProps) => {
  return (
    <DocumentsComponent
      {...(formikProps as any)}
      fileIdentifiers={otherProductClaimFileIdentifiers}
      insurers={insurers}
      existingFiles={existingFiles}
      onDeleteExisting={onDeleteExisting}
      onExistingLabelChange={onExistingLabelChange}
      onUpdateExistingLabel={onUpdateExistingLabel}
      highlightMissingLabels={highlightMissingLabels}
    />
  );
};

export default DocumentsStep;
